import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CreateSpaceModalComponent } from './components/create-space-modal/create-space-modal.component';
import { AddNoteModalComponent } from './components/add-note-modal/add-note-modal.component';
import { DeleteSpaceModalComponent } from './components/delete-space-modal/delete-space-modal.component';
import { ToastComponent } from './components/toast/toast.component';
import { filter } from 'rxjs';
import { MatomoService } from './services/matomo.service';
import { IS_OIDC_CALLBACK_LAUNCH } from './app.config';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        HeaderComponent,
        SidebarComponent,
        CreateSpaceModalComponent,
        AddNoteModalComponent,
        DeleteSpaceModalComponent,
        ToastComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly isOidcCallbackLaunch = inject(IS_OIDC_CALLBACK_LAUNCH);
  currentRoute = '';
  title = 'amplify-app';

  constructor(
    private readonly router: Router,
    private readonly matomoService: MatomoService
  ) {}

  ngOnInit(): void {
    this.matomoService.init();
    if (!this.isOidcCallbackLaunch) {
      this.matomoService.trackAppView();
    }

    this.currentRoute = this.router.url;

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  get isLandingRoute(): boolean {
    return this.currentRoute === '/' || this.currentRoute.startsWith('/landing');
  }

}
